export { default as ProductsIndexContent } from './ProductsIndexContent';
